export default __webpack_public_path__ + "static/media/IMG_8683.c981c52b.JPG";